import { Editor } from "grapesjs";

const customLandingSliderConfig = ({ editor }: { editor: Editor }) => {
	editor.BlockManager.add("custom-slider", {
		label: "Slider",
		category: "Media Slider",
		content: {
			type: "custom-slider",
			components: `
				<div class="py-4 relative group">
					<div class="opacity-0 group-hover:opacity-100 transition-opacity absolute left-3 top-8 p-2 py-1 w-auto h-auto bg-gradient-to-r from-slate-900 to-slate-600 text-white text-xs rounded-md flex flex-col">
						<span>↔ Swipe or scroll horizontally</span>
						<span>🖱 Double-click image to change it</span>
						<span>🎛 Use trait panel to add/remove slides</span>
					</div>
					<div class="overflow-x-auto snap-x snap-mandatory flex space-x-3 pb-2">
						<img src="https://placehold.co/1920x600?text=Double+click+to+change" alt="Slide 1" class="snap-start flex-shrink-0 w-full min-h-48" style="cursor:pointer;"/>
						<img src="https://placehold.co/1920x600?text=Double+click+to+change" alt="Slide 2" class="snap-start flex-shrink-0 w-full min-h-48" style="cursor:pointer;"/>
						<img src="https://placehold.co/1920x600?text=Double+click+to+change" alt="Slide 3" class="snap-start flex-shrink-0 w-full min-h-48" style="cursor:pointer;"/>
					</div>
				</div>
			`,
		},
	});

	// Command: bridge between trait (non-React) and React ImagePopUpV3
	editor.Commands.add("open-slider-image", {
		run(_editor, _sender, options: { onSelect: (url: string) => void }) {
			window.dispatchEvent(
				new CustomEvent("gjs-open-slider-image", {
					detail: { onSelect: options?.onSelect },
				})
			);
		},
	});

	// Trait: slide image manager UI
	editor.TraitManager.addType("slider-images", {
		createInput({ trait }: { trait: any }) {
			const container = document.createElement("div");
			container.style.cssText =
				"display:flex;flex-direction:column;gap:8px;padding:4px 0;";

			const openPicker = (onSelect: (url: string) => void) => {
					editor.Commands.run("open-slider-image", { onSelect } as any);
				};

				const render = () => {
				container.innerHTML = "";

				// Hint note
				const hint = document.createElement("div");
				hint.style.cssText =
					"font-size:10px;color:#555;margin:0 0 8px 0;line-height:1.6;border-left:3px solid #2563eb;background:#f0f5ff;border-radius:0 4px 4px 0;padding:6px 8px;";
				hint.innerHTML =
					"<strong style='display:block;margin-bottom:2px;color:#2563eb;'>Slider Tips</strong>" +
					"🖱 Double-click image on canvas to change<br>" +
					"➕ Click <em>+ Add Slide</em> to add new slide<br>" +
					"📋 To duplicate — copy last slide's image URL";
				container.appendChild(hint);

				const sliderEl = (this as any).target?.find(
					".snap-x, .overflow-x-auto"
				)?.[0];

				if (!sliderEl) {
					const msg = document.createElement("p");
					msg.textContent = "No slider container found.";
					msg.style.cssText = "font-size:11px;color:#999;";
					container.appendChild(msg);
					return;
				}

				const imgs = sliderEl.find("img");

				imgs.forEach((img: any, idx: number) => {
					const row = document.createElement("div");
					row.style.cssText =
						"display:flex;align-items:center;gap:6px;padding:4px;background:#f9f9f9;border-radius:4px;border:1px solid #eee;";

					const thumb = document.createElement("img");
					thumb.src = img.get("attributes")?.src || "";
					thumb.style.cssText =
						"width:52px;height:36px;object-fit:cover;border-radius:3px;border:1px solid #ddd;flex-shrink:0;cursor:pointer;";
					thumb.title = "Double-click to change";

					// Double-click thumbnail opens picker
					thumb.ondblclick = () => {
						openPicker((url: string) => {
							img.set("attributes", { ...img.get("attributes"), src: url });
							render();
						});
					};

					const label = document.createElement("span");
					label.textContent = `Slide ${idx + 1}`;
					label.style.cssText = "font-size:11px;color:#555;flex:1;";

					const changeBtn = document.createElement("button");
					changeBtn.textContent = "Change";
					changeBtn.style.cssText =
						"font-size:11px;padding:3px 8px;cursor:pointer;background:#fff;border:1px solid #ccc;border-radius:3px;";
					changeBtn.onclick = () => {
						openPicker((url: string) => {
							img.set("attributes", { ...img.get("attributes"), src: url });
							render();
						});
					};

					// Duplicate: clone last img with same src
					const dupBtn = document.createElement("button");
					dupBtn.textContent = "⧉";
					dupBtn.title = "Duplicate this slide";
					dupBtn.style.cssText =
						"font-size:12px;padding:3px 6px;cursor:pointer;background:#fff;border:1px solid #ccc;border-radius:3px;flex-shrink:0;";
					dupBtn.onclick = () => {
						const src = img.get("attributes")?.src || "";
						sliderEl.append(
							`<img src="${src}" alt="Slide" class="snap-start flex-shrink-0 w-full min-h-48" style="cursor:pointer;"/>`
						);
						render();
					};

					const removeBtn = document.createElement("button");
					removeBtn.textContent = "✕";
					removeBtn.title = "Remove slide";
					removeBtn.style.cssText =
						"font-size:12px;padding:3px 7px;cursor:pointer;color:#c00;background:#fff;border:1px solid #ecc;border-radius:3px;flex-shrink:0;";
					removeBtn.onclick = () => {
						img.remove();
						render();
					};

					row.append(thumb, label, changeBtn, dupBtn, removeBtn);
					container.appendChild(row);
				});

				const addBtn = document.createElement("button");
				addBtn.textContent = "+ Add Slide";
				addBtn.style.cssText =
					"margin-top:4px;padding:6px 10px;cursor:pointer;width:100%;background:#2563eb;color:#fff;border:none;border-radius:4px;font-size:12px;";
				addBtn.onclick = () => {
					editor.Commands.run("open-slider-image", {
						onSelect: (url: string) => {
							sliderEl.append(
								`<img src="${url}" alt="Slide" class="snap-start flex-shrink-0 w-full min-h-48"/>`
							);
							render();
						},
					} as any);
				};
				container.appendChild(addBtn);
			};

			render();
			return container;
		},
	});

	// Double-click any img inside snap-x on canvas → open picker
	editor.on("component:dblclick", (model: any) => {
		if (model.get("tagName") !== "img") return;
		const parent = model.parent();
		// Check if inside a snap-x slider container
		const isSliderImg =
			parent?.getClasses?.()?.some((c: string) =>
				["snap-x", "overflow-x-auto"].includes(c)
			) ||
			parent?.parent?.()?.getClasses?.()?.some((c: string) =>
				["snap-x", "overflow-x-auto"].includes(c)
			);
		if (!isSliderImg) return;

		editor.Commands.run("open-slider-image", {
			onSelect: (url: string) => {
				model.set("attributes", { ...model.get("attributes"), src: url });
			},
		} as any);
	});

	// Register custom-slider component type with the image manager trait
	editor.DomComponents.addType("custom-slider", {
		model: {
			defaults: {
				tagName: "div",
				draggable: true,
				traits: [{ type: "slider-images", label: "Slides" }],
			},
		},
	});
};

export default customLandingSliderConfig;
